<form [formGroup]="form" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" [disabled]="visibilitySpinner" title="Volver" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar || formInvalid" type="button" title="Guardar" (click)="onSubmit()" class="btn btn-outline-success"><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">
        <h4 style="display:inline">{{editTitle}} Documento {{CodigoSolicitud}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <!--<img class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitud}}" ngbTooltip="{{tituloTipoSolicitud}}" />-->
                <!--<img class="asignada-icono" src="{{ null | IconoSolicitudAsignada}}" />-->
                <!--<label class="codigo-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitud}}">{{CodigoTipoSolicitud}}</label>-->
                <img class="estado-icono-big" container="body" src="{{IdTipoSolicitud | IconoTipoSolicitud}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <img class="estado-icono-big" container="body" src="{{IdEstadoSolicitud | IconoEstadoSolicitud}}" ngbTooltip="{{EstadoSolicitudDescripcion}}" />
                <img *ngIf="documento.IdEstadoChedPp" class="estado-icono-big" container="body" src="{{documento.IdEstadoChedPp | IconoEstadoChedPP}}" ngbTooltip="{{documento.IdEstadoChedPpDescripcion}}" />
                <img *ngIf="IdResultadoEnvioMuestrasLaboratorio" class="estado-icono-big" container="body" src="{{IdResultadoEnvioMuestrasLaboratorio | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{DescripcionIdResultadoEnvioMuestrasLaboratorio}}" />
                <img class="predua-icono-big" container="body" ngbTooltip="{{EsPredua | preduaNoPredua}}" src="{{EsPredua | IconoPreduaSolicitud}}" />
                <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitud}}" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
            </span>
        </h5>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-header">
                    </div>

                    <div class="card-body-detalle">

                        <div class="row">

                            <div class="col-md-3">
                                <label class="col-form-label required-field" for="inpDescripcion">Tipo</label>
                                <ng-select [items]="listTipoDocumentacion"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdTipoDocumentacion"
                                           loadingText="Cargando..."
                                           [loading]="!(listTipoDocumentacion)"
                                           [ngClass]="displayFieldCssNgSelect('IdTipoDocumentacion')"
                                           notFoundText="Tipo de documento no encontrado"
                                           placeholder="-- Seleccione un Tipo --"
                                           clearAllText="Eliminar selección"
                                           (change)="onSelectTipoDocumentacion($event)">

                                    <ng-template ng-option-tmp let-item="item">
                                        <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                    </ng-template>
                                </ng-select>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdTipoDocumentacion','required')">
                                    Tipo documentación es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-3" *ngIf="esTipoDocumentoAttachedTraces">
                                <label class="col-form-label">Certificado Fitosanitario transmitido electrónicamente PHYTO/ePhyto</label>
                                <p-selectButton class="selectButtonCust"
                                                [options]="listSiNo"
                                                formControlName="DescargarTraces"
                                                (onChange)="onChangeSelectDownloadFromTraces($event)"
                                                unselectable="true">
                                </p-selectButton>
                            </div>


                            <div class="form-group col-md-3">
                                <label class="col-form-label" [ngClass]="{ 'required-field' : requerirTexto }" for="inpTexto">Número</label>
                                <input formControlName="Texto" name="Texto" title="" class="form-control" inputStyleClass="form-control"
                                       id="inpTexto" type="text" value="" maxlength="50">

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Texto','required')">
                                    Número es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" [ngClass]="{ 'required-field' : requerirFecha }" for="inpFecha">Fecha</label>
                                <p-calendar formControlName="Fecha" inputStyleClass="form-control" [showIcon]="true"
                                            [firstDayOfWeek]="1" dateFormat="dd/mm/yy" [ngClass]="displayFieldCssCal('Fecha')">
                                </p-calendar>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Fecha','required')">
                                    Fecha es obligatoria
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" [ngClass]="{ 'required-field' : requerirPais }" for="intEstado">País Origen</label>
                                <ng-select [items]="listPais"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdPais"
                                           loadingText="Cargando..."
                                           [loading]="!(listPais)"
                                           notFoundText="País no encontrado"
                                           placeholder="-- Seleccione un País --"
                                           clearAllText="Eliminar selección"
                                           [ngClass]="displayFieldCssNgSelect('IdPais')"
                                           (change)="onSelectPaisOrigen()">
                                    >

                                    <ng-template ng-option-tmp let-item="item">
                                        <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                    </ng-template>
                                </ng-select>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPais','required')">
                                    País Origen es obligatorio
                                </div>
                            </div>

                        </div>
                        <div *ngIf="esInspector || esGrabador" class="row">

                            <div class="form-group col-md-3">
                                <label class="col-form-label">Visible también para solicitante </label>
                                <p-toggleButton [disabled]="!habilitarVisibilidadSolicitante" class="form-control-togglebutton"
                                                formControlName="VisibleInspector" onLabel="Sí" offLabel="NO"
                                                onIcon="pi pi-check" offIcon="pi pi-times" id=""></p-toggleButton>
                            </div>
                        </div>

                        <div *ngIf="esInspector" class="row">


                            <div class="form-group col-md-9">
                                <label class="col-form-label required-field" for="intEstado">Documento</label>
                                <app-document-uploader [parentForm]="form" [parentSubmitted]="submitted" [readOnly]="!habilitarGuardar" [uploadedFile]="uploadedFile" [megaSizeLimit]="megaSizeLimit"
                                                       (fileUploaded)="onFileUploaded($event)">
                                </app-document-uploader>
                            </div>
                            <div class="form-group col-md-4">
                                <label class="col-form-label">Revisado</label>
                                <p-toggleButton class="form-control-togglebutton"
                                                formControlName="esRevisado" onLabel="Sí" offLabel="NO"
                                                onIcon="pi pi-check" offIcon="pi pi-times" id=""></p-toggleButton>
                            </div>


                        </div>


                        <div *ngIf="!esInspector" class="row">

                            <div class="form-group col-md-12">

                                <label class="col-form-label required-field" for="intEstado">Documento</label>

                                <!--UPLOADER LOCAL-->
                                <app-document-uploader *ngIf="habilitarUploaderComponentFromLocal" [parentForm]="form" [parentSubmitted]="submitted" [readOnly]="!habilitarGuardar" [megaSizeLimit]="megaSizeLimit"
                                                       [uploadedFile]="uploadedFile" [isDocumentoDescargable]="isDocumentoDescargable()" (fileUploaded)="onFileUploaded($event)" (fileDeleted)="onFileDeleted($event)">
                                </app-document-uploader>

                                <!--TRACES BUTTON UPLOADER-->
                                <button *ngIf="habilitarButtonDownloadFileFromTraces" class="btn btn-outline-success" style="display:flex" type="button" title="Descargar documento desde TRACES"
                                        [disabled]="isButtonDownloadFileFromTracesDisabled()" (click)="onClickDownloadFileFromTraces()">
                                    <i class="fa fa-download pe-2 pt-2"></i>Descargar<img src="./assets/images/DocTraces/TracesDownload.png" class="estado-icono ps-3"/>
                                </button>


                                <!--TRACES grid info file-->
                                <div *ngIf="habilitarGridInfoFileDownloadedFromTraces" class="row">
                                    <div *ngIf="!downloadedFileFromTraces.MarkToDelete" class="col-md-12">
                                        <div class="table-responsive">
                                            <table class="table table-sm">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 10%"></th>
                                                        <th style="width: 30%">
                                                            Tamaño
                                                        </th>
                                                        <th style="width: 60%">
                                                            Nombre Archivo
                                                        </th>

                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr>

                                                        <td>

                                                            <div class="btn-group" *ngIf="!esSolicitante">

                                                                <button (click)="onDownload()" type="button" title="Descargar documento"
                                                                        class="btn btn-sm btn-danger">
                                                                    <span class="fa fa-download"></span>
                                                                </button>
                                                            </div>

                                                            <div class="btn-group" *ngIf="habilitarGuardar">

                                                                <button (click)="onDelete()" type="button" title="Cambiar documento"
                                                                        class="btn btn-sm  btn-warning">
                                                                    <span class="fa fa-refresh"></span>

                                                                </button>
                                                            </div>


                                                        </td>


                                                        <td>{{getSizeKb() | number:'1.0-2':'es'}} Kb</td>
                                                        <td><img src="./assets/images/DocTraces/TracesDownload.png" class="estado-icono"/>&nbsp;&nbsp;{{downloadedFileFromTraces.Name}}</td>



                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>


                            </div>

                        </div>

                    </div>
                    </div>
            </div>
        </div>


    </div>

</form>
